import { memone, Type } from '@deqo/foundation';
import { ReadStore } from '../../../concepts/revive/ReadStore';
import { WriteStore } from '../../../concepts/revive/WriteStore';

export const CoolReadStore = <S>(templateState: S) => {

    const Impl = class extends ReadStore<S> {
        protected state: S = templateState;
    };

    for (const key of Object.keys(templateState)) {
        Object.defineProperty(Impl.prototype, key, {
            configurable: false,
            get(this: ReadStore<S>) {
                this.guardDestroyed();
                return this.getState()[key];
            },
        });
    }

    return Impl as Type<InstanceType<typeof Impl> & Readonly<S>>;
};

export const CoolWriteStore = <S>(templateState: S) => {

    const Impl = class extends WriteStore<S> {
        protected state: S = templateState;
    };

    for (const key of Object.keys(templateState)) {
        Object.defineProperty(Impl.prototype, key, {
            configurable: false,
            get(this: WriteStore<S>) {
                this.guardDestroyed();
                return this.getState()[key];
            },
        });
    }

    return Impl as Type<InstanceType<typeof Impl> & Readonly<S>>;
};

abstract class KeyedListStoreBase<T, K, S extends T[]> extends WriteStore<S> {

    protected index = new Map<K, T>();

    protected abstract indexer(t: T): K;

    public get(key: K): T {
        return this.index.get(key) ?? null;
    }

    @memone()
    protected getIndex(state: S) {
        return state.reduce(
            (t, x) => t.set(this.indexer(x), x),
            new Map<K, T>()
        );
    }
}

export const KeyedListStore = <T, K, S extends T[]>(templateState: S, indexer: (t: T) => K) => {

    const Impl = class extends KeyedListStoreBase<T, K, S> {
        protected indexer = indexer;
        protected state: S = templateState;
    };

    return Impl as Type<InstanceType<typeof Impl> & Readonly<S>>;
};

// @injectable()
// export class VotingViewState extends CoolWriteStore(initialVotingViewStateData) { }
